// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orakh.ui.message,.memT0.ui.message{align-items:center;display:flex}.orakh.ui.message i.icon:not(.close),.memT0.ui.message i.icon:not(.close){align-self:flex-end;box-shadow:none;color:#fff;flex-shrink:0;font-size:1.4rem}.orakh.ui.message i.icon:not(.close):before,.memT0.ui.message i.icon:not(.close):before{font-size:.9em}.orakh i.icon:not(.close){background-color:var(--sui-color-red);padding:.55rem 0!important}.memT0 i.icon:not(.close){background-color:var(--sui-color-orange)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"critical": `orakh`,
	"warning": `memT0`
};
module.exports = ___CSS_LOADER_EXPORT___;
